// import { optionSelectAll } from "@/utils/commonUtils";

const danhSachCapDonVi = state => state.danhSachCapDonVi;
const danhSachCapDonViPaging = state => state.danhSachCapDonViPaging;

export default {
  danhSachCapDonVi,
  danhSachCapDonViPaging
};
